// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__469CT","wrapper":"styles_wrapper__N3dPb"};